// Holds a File picked on one page to be consumed by another (napkin snap → /generate).
let _pending = null;

export const setPendingUpload = (file) => {
  _pending = file;
};

export const takePendingUpload = () => {
  const f = _pending;
  _pending = null;
  return f;
};
